import { render } from "./PagePayment.vue?vue&type=template&id=4f82fb78"
import script from "./PagePayment.vue?vue&type=script&lang=js"
export * from "./PagePayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__